<template>
  <div>
    <div>
      <transition name="fade">
        <div v-if="isShowUpdateInfo" class="modal">
          <div class="modal-content">
            <div class="text-center login-title">
              <span style="text-transform: uppercase;">
                {{ titleDialogUpdateInfo || $t("regDone") }}
              </span>
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleClose"
              >
                <path
                  d="M13 1L1 13"
                  stroke="#6B6B6B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 1L13 13"
                  stroke="#6B6B6B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <!-- Country code input -->
            </div>
            <div class="d-flex justify-content-center">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.1875 0.0675049C14.4174 0.403839 10.7569 1.86651 7.62817 4.27561C6.10292 5.44887 4.12402 7.65461 2.98204 9.45361C2.48927 10.228 1.5272 12.199 1.18304 13.1377C0.799774 14.1858 0.385221 15.7971 0.181856 17.0407C-0.0606186 18.566 -0.0606186 21.46 0.181856 22.9852C0.533835 25.144 1.08918 26.8805 2.03561 28.8124C3.06808 30.9165 4.13966 32.4105 5.86045 34.1391C7.58906 35.8598 9.08301 36.9314 11.1871 37.9639C13.119 38.9103 14.8555 39.4657 17.0143 39.8177C18.5395 40.0601 21.4336 40.0601 22.9588 39.8177C24.2025 39.6143 25.8137 39.1997 26.8619 38.8165C27.8005 38.4723 29.7715 37.5102 30.5459 37.0175C33.0567 35.4218 35.3954 33.0831 36.991 30.5723C37.4838 29.798 38.4459 27.8269 38.79 26.8883C39.4392 25.1049 39.8851 22.9148 39.9789 20.9516C40.0415 19.747 39.9789 19.4576 39.5957 19.0196C38.7979 18.1123 37.3195 18.5112 37.0458 19.7001C36.9989 19.8956 36.9597 20.318 36.9597 20.6544C36.9597 21.546 36.7407 23.0478 36.4513 24.2054C34.9574 30.1734 30.147 34.9838 24.179 36.4778C21.4492 37.1661 18.4769 37.1583 15.7628 36.4699C9.06737 34.757 4.02234 29.0627 3.13848 22.2187C2.98204 20.9829 2.98204 19.0431 3.13848 17.8072C4.01451 10.971 9.07519 5.26897 15.7628 3.55601C16.9361 3.25878 18.4378 3.03977 19.3452 3.03977C20.4637 3.03195 21.0347 2.77383 21.3241 2.14809C21.6917 1.34245 21.3788 0.513344 20.5732 0.137901C20.229 -0.0185356 19.4468 -0.0419998 18.1875 0.0675049Z"
                  :fill="bg.c_border"
                />
                <path
                  d="M37.4682 5.06554C37.343 5.09683 37.1475 5.16722 37.038 5.2298C36.9285 5.28455 32.7439 9.42226 27.7301 14.4282L18.6178 23.5171L16.3495 21.0532C12.1492 16.4775 11.9302 16.2506 11.5547 16.0864C10.8429 15.7657 9.99819 16.0629 9.66968 16.7434C9.45849 17.1814 9.45849 17.7368 9.65404 18.12C9.78701 18.3782 12.0397 20.8577 16.2947 25.4412C17.7183 26.9743 18.0155 27.2089 18.5787 27.2089C19.2357 27.2089 19.1105 27.3263 29.3101 17.1423C39.8538 6.61425 39.3767 7.13048 39.2907 6.36395C39.189 5.50356 38.2817 4.86217 37.4682 5.06554Z"
                  :fill="bg.c_border"
                />
              </svg>
            </div>
            <div class="mt-10">
              <p v-if="isBeforeUpdate" class="text-center c-body2">
                {{ $t("welcomeWg") }}, {{ $t("yourVid") }}
                <strong class="fw-600">{{ getToken().vga }}</strong
                >. {{ $t("pleaseUpdate") }}. {{ $t("whenJoinWg") }}.
                {{ $t("seeDetail") }}
                <a
                  href="https://hio.wghn.net/terms-of-service/loyalty-membership-policy"
                  target="_blank"
                >
                  <strong class="cursor-pointer fw-600 c-black text-hover">{{
                    $t("here")
                  }}</strong>
                </a>
              </p>
              <p v-else class="text-center c-body2">
                {{ $t("infoUpdateDone") }} <br />
                {{ $t("thankYour") }}
              </p>
            </div>
            <div
              v-if="isBeforeUpdate"
              v-loading="isLoading"
              class="form-input mt-20"
            >
              <div class="widget__capcha mb-10">
                <div class="item  w-100">
                  <input
                    type="text"
                    class="w-100 pl-10"
                    :placeholder="$t('fullName')"
                    v-model="bodyForm.fullname"
                  />
                </div>
              </div>
              <div class="widget__capcha mb-10">
                <div class="item w-100">
                  <datetime
                    class="birth-user full-width"
                    v-model="bodyForm.birthday"
                    format="dd-MM-yyyy"
                    type="date"
                    :placeholder="$t('birth')"
                    :phrases="{
                      ok: $t('confirm'),
                      cancel: $t('wap.text42')
                    }"
                  >
                  </datetime>
                </div>
              </div>
              <div class="widget__capcha mb-10">
                <div class="item w-100">
                  <input
                    type="text"
                    class="w-100 pl-10"
                    :placeholder="$t('emailAddress')"
                    v-model="bodyForm.email"
                  />
                </div>
              </div>
              <div class="widget__capcha mb-10">
                <div class="item w-100">
                  <input
                    type="text"
                    class="w-100 pl-10"
                    :placeholder="$t('wap.text99')"
                    v-model="bodyForm.address"
                  />
                </div>
              </div>
            </div>
            <!-- Login button -->
            <div style="margin-bottom: 50px;" class="mt-20">
              <el-button
                @click="handleUpdate"
                class="btn-main bg-btn-main btn-login"
                :loading="isLoadingSubmit"
              >
                {{ isBeforeUpdate ? $t("update") : $t("wap.text42") }}
              </el-button>
              <p
                @click="handleClose"
                v-if="isBeforeUpdate"
                class="text-center mt-10  cursor-pointer text-hover fw-600 "
              >
                {{ $t("skipLower") }}
              </p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { updateInfoProfile, getDetailUser } from "@/views/api/wapV2/user";
import { mapGetters, mapActions } from "vuex";
import { getToken, setToken, getBackGround } from "@/utils/wapAuth";
import { getLanguage } from "@/utils/wapAuth";
import { Settings } from "luxon";
Settings.defaultLocale = getLanguage() || "vi";
export default {
  name: "DialogUpdateInfoUser",
  data() {
    return {
      isLoadingSubmit: false,
      isLoading: false,
      isBeforeUpdate: true,
      bodyForm: {},
      bg: getBackGround()
    };
  },
  computed: {
    ...mapGetters(["isShowUpdateInfo", "titleDialogUpdateInfo"])
  },
  watch: {
    isShowUpdateInfo(value) {
      if (value) {
        this.onGetInfoUser();
      }
    }
  },

  created() {},
  methods: {
    getToken,
    ...mapActions(["setTitleDialogUpdateInfo"]),
    async handleUpdate() {
      if (!this.isBeforeUpdate) {
        this.handleClose();
        return;
      }
      this.isLoadingSubmit = true;
      const bodyReq = {
        fullname: this.bodyForm.fullname || null,
        address: this.bodyForm.address || null,
        email: this.bodyForm.email || null,
        birthday: this.bodyForm.birthday || null,
        uid: getToken().vga
      };
      console.log("bodyReq___________", bodyReq);

      const res = await updateInfoProfile(bodyReq);
      this.isLoadingSubmit = false;
      if (res.error_code != 0) {
        this.$message.error(res.error_msg);
        return;
      }
      delete bodyReq.uid;
      setToken({ ...getToken(), ...bodyReq });
      this.$store.dispatch("reRenderComponent");

      this.isBeforeUpdate = false;
      this.setTitleDialogUpdateInfo(this.$t("notify"));
    },
    async onGetInfoUser() {
      this.isLoading = true;
      const info = await getDetailUser({ uid: getToken().vga });
      this.bodyForm = {
        fullname: info.data.fullname || null,
        address: info.data.address || null,
        email: info.data.user_email?.email || null,
        birthday: info.data.birthday || null,
        uid: getToken().vga
      };
      this.isLoading = false;

      console.log("info_____________", info);
    },
    handleClose() {
      this.$store.dispatch("setShowUpdateInfo", false);
      this.clearData();
    },
    clearData() {
      (this.isLoadingSubmit = false),
        (this.isBeforeUpdate = true),
        (this.bodyForm = {});
    }
  }
};
</script>
<style>
.birth-user input {
  width: 100%;
  padding-left: 5px;
}
</style>
<style scoped>
.text-center {
  text-align: center;
}

.modal {
  /* Add your modal styles here */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2200;
}

.modal-content {
  width: 90%;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 10px;
  padding-bottom: 0;
}

.login-title {
  margin-bottom: 15px;
  padding-bottom: 15px;
  position: relative;
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  border-bottom: 1px solid #e9e9e9;
}

.login-title svg {
  position: absolute;
  right: 10px;
}

.form-input .widget__capcha input,
.birth-user,
.form-input .phone-input {
  background: rgba(242, 242, 242, 1);
}

.widget__capcha .birth-user,
.item input {
  width: 100%;
  padding: 13.5px 5px 13.5px 5px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.71px;
  letter-spacing: -0.006em;
  border: unset;
  margin-top: unset;
}

.widget__capcha .item input:focus {
  border: unset;
  outline: none;
}

.btn-main,
.btn-main-outline {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 12px;
  color: #fff;
  border-radius: 8px;
  border: unset;
  outline: unset;
  font-size: 12px;
  font-weight: bold;
}
.btn-main:hover {
  color: #fff;
}
.btn-main:focus {
  color: #fff;
}
.btn-main:active {
  color: #fff;
}
.btn-main:disabled,
.modal {
  z-index: 2000;
}

.modal .modal-content {
  max-width: 450px;
}

@media screen and (max-width: 354px) {
  .main-text img {
    width: 55px;
  }
}

.btn-register {
  font-size: 14px;
  font-weight: 700;
}
.btn-login {
  font-size: 16px;
  font-weight: 600;
}
</style>
